/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Textures
 */

module.exports = {

    Parsers: require('./parsers/'),

    FilterMode: require('./FilterMode'),
    Frame: require('./Frame'),
    Texture: require('./Texture'),
    TextureManager: require('./TextureManager'),
    TextureSource: require('./TextureSource')

};



//////////////////
// WEBPACK FOOTER
// ./textures/index.js
// module id = 920
// module chunks = 0